const sections = [
  {
    id: 'compute',
    title: 'İşlem (Compute)',
    body: 'VergeIO, hem Linux hem de Windows konuklarını destekleyen QEMU/KVM tabanlı yerleşik bir hipervizöre sahiptir. Hipervizörümüz, sanal makineleriniz ve sanal veri merkezleriniz için bare-metal düzeyinde işlem performansı sağlar. Daha fazla bilgi edinmek için tıklayın.',
    icon: 'ri-cpu-line',
    imageSeq: 'compute-01',
    imageQuery: 'modern server rack compute nodes processor chips glowing blue circuit board close up data center high performance computing infrastructure professional clean background',
    reverse: false,
    link: 'https://wiki.verge.io/en/public/vms?_gl=1*14ajeh1*_ga*MzA5MjY1MTkuMTc3MzY0Nzk2NQ..*_ga_9J6TF7RB9B*czE3NzQyNjk1MDUkbzQkZzEkdDE3NzQyNzE0MjUkajM0JGwwJGgw*_gcl_au*MjM5NDcxOTQ0LjE3NzM2NDc5NjU.',
  },
  {
    id: 'storage',
    title: 'Depolama (Storage)',
    body: 'Sanal SAN\'ımız, büyük veri depoları ve NAS birimleri için büyük ölçekli mimari sunar. Blockchain benzeri teknoloji kullanılarak depolama alanınız şifrelenir, ultra güvenli hale getirilir ve yalnızca benzersiz veriler yazıldığında büyür; ister tek bir VM\'yi ister 100 tanesini klonlayın fark etmez.',
    icon: 'ri-database-2-line',
    imageSeq: 'storage-01',
    imageQuery: 'enterprise storage array SAN NAS data center disk drives RAID blue glowing lights high capacity server room professional photography ultra modern clean',
    reverse: true,
    link: 'https://wiki.verge.io/en/public/storage?_gl=1*14ajeh1*_ga*MzA5MjY1MTkuMTc3MzY0Nzk2NQ..*_ga_9J6TF7RB9B*czE3NzQyNjk1MDUkbzQkZzEkdDE3NzQyNzE0MjUkajM0JGwwJGgw*_gcl_au*MjM5NDcxOTQ0LjE3NzM2NDc5NjU.',
  },
  {
    id: 'network',
    title: 'Ağ İletişimi (Network)',
    body: 'VergeIO, tam ağ yönetimi için yazılım tabanlı bir araçlar ve yönetim katmanı sunar. Her ağ, entegre bir güvenlik duvarı ve yaygın ağ hizmetlerini içerir. Karmaşık ağ topolojileri bile VergeOS ile kolayca yapılandırılabilir.',
    icon: 'ri-router-line',
    imageSeq: 'network-01',
    imageQuery: 'software defined networking SDN data center fiber optic cables switches routers glowing orange network infrastructure modern server room professional ultra clean photography',
    reverse: false,
    link: 'https://wiki.verge.io/en/public/networking?_gl=1*14ajeh1*_ga*MzA5MjY1MTkuMTc3MzY0Nzk2NQ..*_ga_9J6TF7RB9B*czE3NzQyNjk1MDUkbzQkZzEkdDE3NzQyNzE0MjUkajM0JGwwJGgw*_gcl_au*MjM5NDcxOTQ0LjE3NzM2NDc5NjU.',
  },
];

export default function ArchSections() {
  return (
    <section className="w-full bg-[#f8f9fb] py-20 px-6">
      <div className="max-w-[1280px] mx-auto space-y-20">
        {sections.map((sec) => (
          <div
            key={sec.id}
            id={sec.id}
            className={`flex flex-col ${sec.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`}
          >
            {/* Text */}
            <div className="flex-1">
              <span className="w-12 h-12 flex items-center justify-center bg-[#e8600a]/10 rounded-xl mb-5">
                <i className={`${sec.icon} text-[#e8600a] text-2xl`}></i>
              </span>
              <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">{sec.title}</h2>
              <p className="text-[#374151] text-base leading-relaxed mb-5">{sec.body}</p>
              <a
                href={sec.link}
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 text-sm font-semibold text-[#e8600a] hover:underline cursor-pointer"
              >
                Daha Fazla Bilgi
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </div>

            {/* Image */}
            <div className="flex-1">
              <div className="w-full h-[280px] rounded-xl overflow-hidden border border-gray-100">
                <img
                  src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg$%7BencodeURIComponent%28sec.imageQuery%29%7D&width=600&height=280&seq=${sec.imageSeq}&orientation=landscape`}
                  alt={sec.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
